import { ref, watch, SetupContext } from '@vue/composition-api'

export function routerUtil(ctx: SetupContext) {
    const oRoute = ctx.root.$route
    const oRouter = ctx.root.$router
    const query = oRoute.query
    const params = oRoute.params
    const getLastPath = (pathname: string) => {
        return pathname.split('/')[pathname.split('/').length - 1]
    }
    let curTabName = getLastPath(oRoute.path)
    // reactive data
    const activeTabName = ref(curTabName)

    watch(() => ctx.root.$route.path, (newVal) => {
        activeTabName.value = curTabName = getLastPath(newVal)
    })

    const handleTabClick = (tab: { paneName: string }) => {
        const paneName = tab.paneName
        if (paneName === curTabName) {
            return
        }
        curTabName = paneName
        oRouter.replace({
            path: paneName,
            query,
            params
        })
    }

    return {
        activeTabName,
        handleTabClick
    }
}
